// Third-party Library
import React from "react";
import { Card } from "antd";

// Styles
import styles from './index.module.css'

const SectionCard = ({ title, subtitle, extra, children, bodyStyle }) => {

    return (
        <Card
            bordered={false}
            styles={{
                body: { padding: 22, ...bodyStyle }
            }}
            className={styles["container-card"]}
        >
            <div className={styles["container"]}>
                <div>
                    <div className={styles["title"]}>{title}</div>
                    { subtitle && <div className={styles["subtitle"]}>{subtitle}</div> }
                </div>
                {extra}
            </div>
            <div style={{ marginTop: 16 }}>{children}</div>
        </Card>
    );
}

export default React.memo(SectionCard)